<div class="element" style="margin-left: 10px;">
  <div class="pcc-field">
    <div class="pcc-field-label">Name</div>
    <div class="pcc-field-text-value">
      <dx-text-box [(value)]="pumpSet.name">
      </dx-text-box>
    </div>
  </div>
  <div class="pcc-field-error">
    {{errors[error.pumpsetname]}}
  </div>  
  <dx-button text="Save to My Pumpsets" (onClick)="doSave()"></dx-button>  
  <div style="margin-top: 20px;">
    <dx-check-box text="Show History" [(value)]="showHistory"></dx-check-box>
  </div>
  <div *ngIf="showHistory" class="audit" [innerHtml]="pumpSet.dataComment">
  </div>